import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import isEqual from 'lodash/isEqual';

import RemoteButtonComponent from 'app/components/shared/RemoteButtonComponent';

import JobInformationStore from 'app/stores/JobInformationStore';

import Database from 'app/lib/Database';

/* eslint-disable react/prefer-es6-class */
// TODO: Move to a class

export default createReactClass({
  displayName: "JobArtifacts",

  propTypes: {
    job: PropTypes.shape({
      id: PropTypes.string.isRequired,
      artifactCount: PropTypes.number,
      basePath: PropTypes.string.isRequired
    }).isRequired
  },

  _getFromStore() {
    return Database.parse(JobInformationStore.get(this.props.job.id, "artifacts"));
  },

  _refetchStore() {
    return JobInformationStore.refetch(this.props.job.id, "artifacts", this.props.job.basePath + "/artifacts");
  },

  _setStoreData(artifacts) {
    return JobInformationStore.set(this.props.job.id, "artifacts", artifacts);
  },

  getInitialState() {
    return {
      artifacts: this._getFromStore()
    };
  },

  componentDidMount() {
    JobInformationStore.addChangeListener(this._onStoreChange);
    this._refetchStore();
  },

  componentWillUnmount() {
    JobInformationStore.removeChangeListener(this._onStoreChange);
  },

  shouldComponentUpdate(nextProps, nextState) {
    return (this.props.job.artifactCount !== nextProps.job.artifactCount) ||
      !isEqual(this.state.artifacts, nextState.artifacts);
  },

  componentDidUpdate(prevProps) {
    if (prevProps.job.artifactCount !== this.props.job.artifactCount) {
      this._refetchStore();
    }
  },

  artifactListNodes() {
    return this.state.artifacts.map((artifact, index, list) => {
      const checksumNode = (
        artifact.sha1sum
          && (
            <small
              className="flex-auto right-align text-muted overflow-hidden overflow-ellipsis"
            >
              {artifact.sha1sum}
            </small>
          )
      );

      const isLastItem = index === (list.length - 1);

      const paddingClass = (
        index === 0
          ? 'pb2'
          : (
            isLastItem
              ? 'pt2'
              : 'py2'
          )
      );

      const borderClass = (
        !isLastItem
          ? ' border-bottom border-gray'
          : ''
      );

      if (artifact.state === "deleted") {
        return (
          <div className={`${paddingClass}${borderClass}`}>
            This artifact has been deleted.
          </div>
        );
      }

      return (
        <div
          key={artifact.id}
          className={`flex items-start px1 ${paddingClass}${borderClass} ${artifact.state}`}
        >
          <div className="items-center flex-none mr3">
            {this.renderArtifactIcon(artifact)}
          </div>
          <div className="flex-auto flex flex-column">
            <div className="flex-auto flex flex-wrap items-center">
              {this.renderArtifactLink(artifact)}
              <small className="text-muted">{artifact.fileSize}</small>
            </div>
            <div className="flex-auto flex flex-wrap items-center">
              <small className="text-muted">{artifact.mimeType}</small>
              {checksumNode}
            </div>
          </div>
          <div className="items-center flex-none ml3">
            {this.renderDeleteButton(artifact)}
          </div>
        </div>
      );
    });
  },

  renderArtifactIcon(artifact) {
    if (artifact.state === "finished") {
      return <i className="fa fa-file-o" />;
    } else if (artifact.state === "error") {
      return <i className="fa fa-file-o red" />;
    }

    return <i className="fa fa-file-o dark-gray" />;
  },

  renderArtifactLink(artifact) {
    if (artifact.state === "finished") {
      return (
        <a
          href={artifact.url}
          title={artifact.path}
          className="flex-auto flex items-center overflow-hidden overflow-ellipsis"
          target="_blank"
          rel="noopener noreferrer"
        >
          {artifact.path}
        </a>
      );
    } else if (artifact.state === "error") {
      return (
        <span
          className="flex-auto flex items-center red overflow-hidden overflow-ellipsis"
        >
          {`${artifact.path} (failed to upload, see log for details)`}
        </span>
      );
    } else if (artifact.state === "new") {
      return (
        <span
          className="flex-auto flex items-center dark-gray overflow-hidden overflow-ellipsis"
        >
          {`${artifact.path} (uploading…)`}
        </span>
      );
    }
  },

  renderDeleteButton(artifact) {
    if ((artifact.state === "finished") && artifact.canDeleteArtifact.allowed) {
      const confirmText = (
        artifact.selfHosted
          ? "As this file is not hosted by Buildkite, deleting it will remove the record from our database, but the file will remain where it was uploaded to. Are you sure you want to delete it?"
          : "Deleting this artifact will remove it from Buildkite and the file will be permanently deleted from our systems. This action cannot be undone. Are you sure you want to delete it?"
      );

      return (
        <RemoteButtonComponent
          url={this.props.job.basePath + `/artifacts/${artifact.id}`}
          method="delete"
          confirmText={confirmText}
          onSuccess={this.handleArtifactDeleteSuccess}
          tooltipText="Delete"
          className="center dark-gray"
        >
          <i className="fa fa-trash hover-black" />
        </RemoteButtonComponent>
      );
    }
  },

  handleArtifactDeleteSuccess(event, data) {
    return this._setStoreData(JSON.parse(data));
  },

  render() {
    return (
      <div
        data-testid="JobArtifactsComponent"
        className="artifacts-list"
      >
        {this.state.artifacts && this.state.artifacts.length ? (
          <div className="artifacts-table">
            {this.artifactListNodes()}
          </div>
        ) : (
          this.state.artifacts && this.state.artifacts.length === 0 ? (
            <p className="m0">There are no artifacts for this job.</p>
          ) : (
            <span>Loading…</span>
          )
        )}
      </div>
    );
  },

  _onStoreChange() {
    return this.setState({ artifacts: this._getFromStore() });
  },

  _onBuildPageStoreChange() {
    return this._refetchStore();
  }
});
